import React, { forwardRef } from 'react'
import CommonCheckbox from 'common/components/entities/Checkbox'
import CommonText from 'common/components/entities/TextNew/ui/TextUi'
import { BaseCheckboxInterface } from 'common/types/entities/CheckboxInterface'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { useThemeColor } from 'src/publisher/shared/hooks/use-theme-color'
import { useCalculateTypography } from 'src/publisher/shared/hooks/use-calculate-typography'

export interface BasePublisherCheckboxProps {
  entity: BaseCheckboxInterface
  checked: boolean
  onChange: () => void
}

export const BasePublisherCheckbox = forwardRef<
  HTMLDivElement,
  BasePublisherCheckboxProps
>(({ entity, checked, onChange }, ref) => {
  const {
    text: { paragraphTextColor: globalTextColor },
    links: { linkTextColor: globalLinkColor },
  } = useThemeColor()

  const {
    calculatedFontSize,
    calculatedLineHeight,
    calculatedTextAlign,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateTypography({
    fontSize: entity.fontSize,
    mobileFontSize: entity.mobileFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    textAlign: entity.textAlign || 'left',
    mobileTextAlign: entity.mobileTextAlign || 'left',
    fontFamily: entity.fontFamily,
    mobileFontFamily: entity.mobileFontFamily,
    fontWeight: entity.fontWeight,
    mobileFontWeight: entity.mobileFontWeight,
    fontStyle: entity.fontStyle,
    mobileFontStyle: entity.mobileFontStyle,
  })

  return (
    <StyleWrapper
      mobileMargin={entity.mobileMargin}
      margin={entity.margin}
      appearance={entity.appearance}
    >
      <CommonCheckbox
        entity={entity}
        checked={checked}
        onChangeHandler={onChange}
      >
        <CommonText
          id={entity.htmlAttrId}
          linkColor={globalLinkColor}
          fontSize={calculatedFontSize.desktop}
          mobileFontSize={calculatedFontSize.mobile}
          lineHeight={calculatedLineHeight.desktop}
          mobileLineHeight={calculatedLineHeight.mobile}
          color={entity.color || globalTextColor}
          fontFamily={calculatedFontFamily.desktop}
          mobileFontFamily={calculatedFontFamily.mobile}
          fontStyle={calculatedFontStyle.desktop}
          mobileFontStyle={calculatedFontStyle.mobile}
          fontWeight={calculatedFontWeight.desktop}
          mobileFontWeight={calculatedFontWeight.mobile}
          padding={entity.padding}
          mobilePadding={entity.mobilePadding}
          textAlign={calculatedTextAlign.desktop}
          mobileTextAlign={calculatedTextAlign.mobile}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: entity.content || entity.html || '',
            }}
            ref={ref}
          />
        </CommonText>
      </CommonCheckbox>
    </StyleWrapper>
  )
})
